import styled from 'styled-components';
import { Media } from 'enums';
import { Text } from 'view/atoms/Text';

type BadgeStyleProps = {
  $backgroundColor: string;
  $textColor: string;
};

export const Badge = styled.div<BadgeStyleProps>`
  box-sizing: border-box;
  width: fit-content;
  max-width: 100%;
  min-height: 30px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 8px 12px;
  border-radius: 8px;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  color: ${({ $textColor }) => $textColor};

  // TODO: add media queries for other screen sizes
  @media ${Media.notebook} {
    min-height: 40px;
    padding: 12px 16px;
  }
`;

export const BadgeLabel = styled(Text)<{ $textColor: string }>`
  && {
    color: ${({ $textColor }) => $textColor};
  }
`;
